import React, { useState } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { useTicketContext } from '../../../../TicketContext';
import style from './style';
import { Layout, Core, Form, Drawer, Modal, Localization } from 'connex-cds';
import {
  useCompanySetup,
  useFormsAndWaiversSetup,
  useVehicleSetup,
  useVehicleTypeSetup,
} from '../../../../MasterDataProvider';
import { activeFormsAndWaiversArray } from '../../../../getActiveForms';

const { Column, Row } = Layout;

const Styled = styled.div`
  ${style}
`;

const DamageWaiver = () => {
  const { translateObjects } = Localization.useTranslateObjects();
  const { userLocale } = Localization.useLocalizationContext();
  const { ticket } = useTicketContext();
  const formsAndWaiversSetup = useFormsAndWaiversSetup();
  const vehicleSetup = useVehicleSetup();
  const companySetup = useCompanySetup();
  const vehicleTypeSetup = useVehicleTypeSetup();
  const {
    Components: { DamageWaiverSignature },
    setFieldValue,
    values,
  } = Form.useFormContext();
  const { closeDrawer } = Drawer.useDrawerContext();
  const { closeModal } = Modal.useModalContext();
  const [signature, setSignature] = useState(false);

  const activeFormsAndWaivers = React.useMemo(
    () =>
      activeFormsAndWaiversArray({
        ticket,
        formTypeCondition: 'DAMAGE',
        formsAndWaiversSetup,
        vehicleSetup,
        vehicleTypeSetup,
        companySetup,
        translateObjects,
        userLocale,
      }),
    [ticket, formsAndWaiversSetup, vehicleSetup, vehicleTypeSetup, companySetup, translateObjects, userLocale]
  );

  const disableSubmitSignature = React.useMemo(() => {
    return !values?.damageWaiverSignature?.image;
  }, [values?.damageWaiverSignature]);

  const handleDeclineDamageWaiver = React.useCallback(() => {
    setFieldValue('damageWaiverSignature', undefined);
    setFieldValue('damageWaiverDeclined', true);
    closeModal();
    closeDrawer();
  }, [setFieldValue]);

  const handleAcceptDamageWaiver = React.useCallback(() => {
    setSignature(true);
  }, []);

  const handleAcceptCancelSignature = React.useCallback(() => {
    setFieldValue('damageWaiverSignature', undefined);
    setSignature(false);
  }, [setFieldValue]);

  const handleSubmitSignature = React.useCallback(() => {
    setFieldValue('damageWaiverDeclined', false);
    closeModal();
    closeDrawer();
  }, [closeDrawer]);

  return (
    <Styled className={cn('damage-waiver')}>
      <Core.Spinner spin={vehicleSetup.isLoading || formsAndWaiversSetup.isLoading || companySetup.isLoading}>
        {!signature ? (
          <Column>
            <div data-testid="damageWaiver">
              <pre className={'damage-waiver-value'}>
                {activeFormsAndWaivers[0]?.label ?? activeFormsAndWaivers[0]?.content}
              </pre>
            </div>
            <Row>
              <Core.Button
                type="primary"
                stringId="accept"
                onClick={handleAcceptDamageWaiver}
                data-testid="accept-button"
              />
              <Core.Button
                type="primary"
                stringId="decline"
                onClick={handleDeclineDamageWaiver}
                data-testid="decline-button"
              />
            </Row>
          </Column>
        ) : (
          <div className="damagewaiversignature">
            <DamageWaiverSignature edit ticketId={ticket?.ticketId} />
            <Row className="actions">
              <Row>
                <Core.Button
                  onClick={handleAcceptCancelSignature}
                  stringId="cancel-signature-button"
                  data-testid="cancel-signature-button"
                />
                <Core.Button
                  type="primary"
                  disabled={disableSubmitSignature}
                  onClick={handleSubmitSignature}
                  stringId="submit-signature-button"
                  data-testid="ok-button"
                />
              </Row>
            </Row>
          </div>
        )}
      </Core.Spinner>
    </Styled>
  );
};

export default DamageWaiver;
